import { render, staticRenderFns } from "./scienceList.vue?vue&type=template&id=38a9c6ba&scoped=true&"
import script from "./scienceList.vue?vue&type=script&lang=js&"
export * from "./scienceList.vue?vue&type=script&lang=js&"
import style0 from "./scienceList.vue?vue&type=style&index=0&id=38a9c6ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a9c6ba",
  null
  
)

component.options.__file = "scienceList.vue"
export default component.exports